RivalIQ.apps.Overview.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const Dashboard = RivalIQ.apps.Dashboard;

    const config = [
        {
            name: 'overview-glance',
            sizes: {
                md: 12
            },
            page: 0
        },
        {
            name: 'overview-top-performing-posts',
            sizes: {
                md: 12
            },
            page: 0
        },
        {
            name: 'landscape-comparisons',
            sizes: {
                md: 12
            },
            page: 1
        }
    ];

    const DETECT_SCROLL_MS = 5000;
    const MIN_PAGE_VIEWED_PCT = 0.05;

    function sendViewedRealMetric(curation) {
        if (!curation.viewedOverviewRealSent) {
            const channel = curation.getProp('channel') || 'cross_channel';
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedOverviewReal, {
                channel: channel
            });
            curation.viewedOverviewRealSent = true;
            $(window).unbind('scroll');
            clearTimeout($.data(window, 'pageViewTimer'));
        }
    }

    function setupViewedRealTracking(curation) {
        // views tab for longer than DETECT_SCROLL_MS ms
        $.data(window, 'pageViewTimer', setTimeout(function () {
            sendViewedRealMetric(curation);
        }, DETECT_SCROLL_MS));

        // OR scrolls past MIN_PAGE_VIEWED_PCT % of page
        const windowEvents = $._data(window, 'events');
        const hasScroll = _.get(windowEvents, 'scroll');
        if (!hasScroll) {
            $(window).scroll(function (e) {
                const postContainer = $('.top-performing-posts-usage');
                const pctDownPage = postContainer.length ? document.documentElement.scrollTop / postContainer[0].clientHeight : 0;
                if (pctDownPage > MIN_PAGE_VIEWED_PCT) {
                    sendViewedRealMetric(curation);
                }
            });
        }
    }

    function verifyChannel(curation) {
        const channel = curation.getProp('channel');

        const validChannels = _.map(curation.getSwitchableItems(), 'value');
        if (channel && !_.includes(validChannels, channel)) {
            return '/overview';
        }
    }


    const NotOnChannelView = Marionette.ItemView.extend({
        template: '#overviewNotOnChannelTemplate',
        className: 'user-action-prompt overview-not-on-channel',

        serializeData: function () {
            const me = this;

            const focusedCompanyId = RivalIQ.state.utils.getFocusedCompanyId();
            const focusCompany = RivalIQ.state.landscape.getCompanyById(focusedCompanyId);
            const channel = me.model.get('channel');

            return {
                channel: channel,
                companyName: (focusCompany ? focusCompany.get('name') : ''),
                channelName: RivalIQ.data.channels.get(channel).get('name')
            };
        }
    });

    const NotOnAnyChannelsView = Marionette.ItemView.extend({
        template: '#overviewNotOnAnyChannelTemplate',
        className: 'user-action-prompt overview-not-on-channel',

        serializeData: function () {
            const me = this;

            const focusCompany = RivalIQ.state.landscape.getCompanyById(me.model.get('focusCompanyId'));
            return {
                companyName: focusCompany.get('name')
            };
        }
    });

    function notOnChannel(curation) {
        const focusCompanyId = curation.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const channel = curation.getProp('channel');

        if (channel) {
            const source = RivalIQ.data.channels.get(channel).get('source');
            const focusCompanyChannelData = (focusCompany ? focusCompany.getPrimaryRecord(source) : null);
            if (!focusCompanyChannelData) {
                return new NotOnChannelView({
                    model: new Backbone.Model({
                        focusCompanyId: focusCompanyId,
                        channel: channel
                    })
                });
            }
        } else {
            const enums = RivalIQ.enums;
            const subSources = enums.sourceDetails[enums.sources.CROSS_CHANNEL].subSources;
            const anyRecords = _.some(subSources, function (source) {
                if (RivalIQ.state.account.channelDisplay(source)) {
                    return (focusCompany ? focusCompany.getPrimaryRecord(source) : null);
                }
            });
            if (!anyRecords) {
                return new NotOnAnyChannelsView({
                    model: new Backbone.Model({
                        focusCompanyId: focusCompanyId
                    })
                });
            }
        }
    }

    const debouncedReload = _.debounce(function (view) {
        view.reload();
    });

    const OverviewCurationView = App.views.LayoutWithBenchmarkChooser.extend({
        config: config,
        template: '#overviewCurationLayoutTemplate',

        dashboardModelEvents: {
            // need to debounce this as it's possible that we'll get called with several changes in rapid succession. See #18397
            'change': 'onModelChange'
        },

        regions: {
            regionContainer: '.dashboard-regions',
            actions: {
                selector: '.x-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            leftActions: {
                selector: '.x-left-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            notOnChannel: '.x-not-on-channel',
            dashboardError: '.dashboard-error'
        },

        ui: {
            widgets: '.dashboard-regions'
        },

        toggleView: function () {
            const me = this;

            if (me.isDestroyed) {
                return;
            }

            const notOnChannelView = notOnChannel(me);
            if (notOnChannelView) {
                me.notOnChannel.show(notOnChannelView);
                me.notOnChannel.$el.show();
                me.actions.$el.hide();
                me.ui.widgets.hide();
                me.dashboardError.$el.hide();
            } else if (me.invalidDateError) {
                me.notOnChannel.$el.hide();
                me.actions.$el.hide();
                me.ui.widgets.hide();
                me._showInvalidDateError();
            } else {
                me.notOnChannel.$el.hide();
                me.actions.$el.show();
                me.ui.widgets.show();
                me.dashboardError.$el.hide();
            }
        },

        onRenderLoaded: function () {
            const me = this;

            me.showToolbars();
            me.toggleView();
        },

        refresh: function () {
            const me = this;
            me.toggleView();
        },

        onModelChange: function () {
            const me = this;
            debouncedReload(me);
        }
    });

    curations.Overview = Dashboard.models.Curation.mixin({
        mixins: {
            ChannelSwitchable: Dashboard.mixins.ChannelSwitchable,
            curationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            verifyChannel,
            Dashboard.curations.filters.channelWall
        ],

        afterFilters: [
            setupViewedRealTracking
        ],

        getExportTitle: function () {
            const me = this;

            const channelName = RivalIQ.data.channels.get(me.getProp('channel')).get('name');
            return `${channelName} Overview`;
        },

        widgetDefinitions: function () {
            const me = this;
            let widgets = [
                {
                    instanceId: 'overview-glance',
                    widgetId: widgetTypes.GLANCE_UNIVERSAL,
                    props: {

                    },
                    region: 'overview-glance'
                },
                {
                    instanceId: 'overview-top-performing-posts',
                    widgetId: widgetTypes.OVERVIEW_TOP_POSTS,
                    props: {
                        dimension: 'companyId',
                        limit: 4,
                        objectType: 'post',
                        metrics: [
                            {
                                property: 'post'
                            }
                        ]
                    },
                    region: 'overview-top-performing-posts'
                }
            ];

            const channel = me.getProp('channel');
            const getFooterPrefix = function () {
                const focusCompany = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId'));
                const companyName = (focusCompany ? focusCompany.get('name') : '');
                const companyNamePossessive = App.utils.makePossessive(_.trim(companyName));
                const channelDef = RivalIQ.data.channels.get(channel);
                const footerTextPrefix = [
                    companyNamePossessive,
                    (channelDef ? channelDef.get('name') : '')
                ].join(' ');
                return footerTextPrefix;
            };

            if (channel) {
                widgets = widgets.concat([{
                    instanceId: 'audience-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} ${RivalIQ.metric.names.metricName({
                            property: 'presence_reach',
                            channel: channel,
                            dimensions: ['channel']
                        })}`;
                    },
                    props: {
                        metrics: [
                            {
                                property: 'presence_reach',
                                dimensions: ['channel', 'timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View audience leaderboard',
                    footerUrl: `/leaderboard/${channel}?scrollToSection=audience`
                },
                {
                    instanceId: 'social-activity-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} ${RivalIQ.metric.names.metricName({
                            property: 'count',
                            channel: channel,
                            dimensions: ['channel']
                        })}`;
                    },
                    props: {
                        metrics: [
                            {
                                property: (channel === RivalIQ.enums.channels.TWITTER ? 'all_avg_count_per_week' : 'avg_count_per_week'),
                                exclusionDimension: (channel === RivalIQ.enums.channels.TWITTER ? 'tweetType' : undefined),
                                dimensions: ['channel', 'timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View activity leaderboard',
                    footerUrl: `/leaderboard/${channel}?scrollToSection=activity`
                },
                {
                    instanceId: 'engagement-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} Engagement`;
                    },
                    props: {
                        metrics: [
                            {
                                property: 'engagement_total',
                                exclusionDimension: 'engagement_type',
                                dimensions: ['channel', 'timeAnalysisMode']
                            }, {
                                property: 'avg_engagement_rate_per_post',
                                dimensions: ['channel', 'timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View engagement leaderboard',
                    footerUrl: `/leaderboard/${channel}?scrollToSection=engagement`
                }]);

                if (_.includes([RivalIQ.enums.channels.TIKTOK, RivalIQ.enums.channels.YOUTUBE], channel)) {
                    widgets = widgets.concat([{
                        instanceId: 'engagement-total-per-view-comparison',
                        widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                        title: function () {
                            const footerPrefixText = getFooterPrefix();
                            return `${footerPrefixText} Views`;
                        },
                        props: {
                            metrics: [
                                {
                                    property: 'views',
                                    channel: channel,
                                    dimensions: ['channel', 'timeAnalysisMode']
                                },
                                {
                                    property: 'engagement_total_per_view',
                                    channel: channel,
                                    dimensions: ['channel', 'timeAnalysisMode']
                                }
                            ]
                        },
                        region: 'landscape-comparisons',
                        footerText: 'View leaderboard',
                        footerUrl: `/leaderboard/${channel}?scrollToSection=views`
                    }]);
                }
            } else {
                // cross-channel
                widgets = widgets.concat([{
                    instanceId: 'audience-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} Audience`;
                    },
                    props: {
                        metrics: [
                            {
                                property: 'audience',
                                exclusionDimension: 'channel',
                                dimensions: ['timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View audience leaderboard',
                    footerUrl: '/leaderboard?scrollToSection=audience'
                },
                {
                    instanceId: 'social-activity-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} Activity`;
                    },
                    props: {
                        metrics: [
                            {
                                property: 'avg_count_per_week',
                                exclusionDimension: 'channel',
                                dimensions: ['timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View activity leaderboard',
                    footerUrl: '/leaderboard?scrollToSection=activity'
                },
                {
                    instanceId: 'engagement-comparison',
                    widgetId: widgetTypes.OVERVIEW_LANDSCAPE_COMPARISON,
                    title: function () {
                        const footerPrefixText = getFooterPrefix();
                        return `${footerPrefixText} Engagement`;
                    },
                    props: {
                        metrics: [
                            {
                                property: 'engagement_total',
                                exclusionDimension: 'channel',
                                dimensions: ['timeAnalysisMode']
                            }
                        ]
                    },
                    region: 'landscape-comparisons',
                    footerText: 'View engagement leaderboard',
                    footerUrl: '/leaderboard?scrollToSection=engagement'
                }]);
            }

            return widgets;
        },

        widgetsView: OverviewCurationView,

        processProps: function (props) {
            props.useUniversalMetricsApi = true;

            return props;
        }
    });
});
